import type {
  InvoiceOfferFeeRateCreateWire,
  InvoiceOfferFeeRateUpdateWire
} from '@klear/invoice-offer-fee-rate/invoice-offer-fee-rate.wire'
import type { InvoiceOfferFeeRate } from '@klear/invoice-offer-fee-rate/invoice-offer-fee-rate'
import { SUBSCRIPTION_TIER_LAUNCH } from '@klear/constants/subscription-tier'
import type { RatingScale } from '@klear/constants'

export type InvoiceOfferFeeRateForm = {
  ratingScale: RatingScale
  rating: string
  subscriptionTierName: InvoiceOfferFeeRateCreateWire['subscriptionTierName']
  annualizedRate: number
}

export const EMPTY_INVOICE_OFFER_FEE_RATE_FORM: InvoiceOfferFeeRateForm = {
  ratingScale: 'IG',
  rating: '',
  subscriptionTierName: SUBSCRIPTION_TIER_LAUNCH,
  annualizedRate: 0
}

export function invoiceOfferFeeRateToForm(source: InvoiceOfferFeeRate): InvoiceOfferFeeRateForm {
  return {
    ratingScale: source.ratingScale,
    rating: source.rating,
    subscriptionTierName: source.subscriptionTierName,
    annualizedRate: source.annualizedRate.value
  }
}

export function invoiceOfferFeeRateFormToCreateWire(form: InvoiceOfferFeeRateForm): InvoiceOfferFeeRateCreateWire {
  return {
    ratingScale: form.ratingScale,
    rating: form.rating,
    subscriptionTierName: form.subscriptionTierName,
    annualizedRate: form.annualizedRate
  }
}

export function invoiceOfferFeeRateFormToUpdateWire(
  form: Pick<InvoiceOfferFeeRateForm, 'annualizedRate'>,
  id: InvoiceOfferFeeRateUpdateWire['id']
): InvoiceOfferFeeRateUpdateWire {
  return {
    id,
    annualizedRate: form.annualizedRate
  }
}
